export default function({ commit }, query) {
    if (query.email)
        commit('validatedEmail', query.email)
    if (query.reset_token)
        commit('validatedResetToken', query)
    if (query.upgrade_token)
        commit('validatedUpgradeToken', query)
}
